import { DEFAULT_ERROR } from 'constants/error';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { GetGeneralPractitionerOperationResponse } from '../../types/entities';

import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';
import { get as getProxy } from '@helsenorge/framework-utils/hn-proxy-service';
import { OperationResponse, TextMessage } from '@helsenorge/framework-utils/types/entities';

import { RootState } from '../';
import { getGeneralPractitionerError, getGeneralPractitionerIsFetching, getGeneralPractitionerResponse } from './selectors';

function shouldFetchGeneralPractitioner(state: RootState): boolean {
  return !getGeneralPractitionerResponse(state) && !getGeneralPractitionerIsFetching(state) && !getGeneralPractitionerError(state);
}

export const fetchGeneralPractitioner = createAsyncThunk<
  GetGeneralPractitionerOperationResponse,
  void,
  { state: RootState; rejectValue: TextMessage }
>(
  'generalpractitioner/get',
  async (_, { rejectWithValue }) => {
    return await getProxy('todlegacy', 'api/v1/MinHelse/GetGeneralPractitioner')
      .then((data: Response | null | object) => {
        return data as GetGeneralPractitionerOperationResponse;
      })
      .catch((error: OperationResponse) => {
        return rejectWithValue(error.ErrorMessage || DEFAULT_ERROR);
      });
  },
  {
    condition: (_, { getState }) => {
      const state = getState();
      return isAuthorized() && shouldFetchGeneralPractitioner(state);
    },
  }
);
